import { useCallback, useState } from 'react'
import { gql, useMutation } from '@apollo/client'
import validate from './validation'
export default (onSuccess, onError) => {
const [mutation, { data, error, loading}] = useMutation(
    gql`mutation update($updatedCountry: UpdateCountryInput!, $countryId: ID!){
    updateCountry(countryUpdate: $updatedCountry, countryId: $countryId) {
      id
      code
      defaultStudentRate
      servicesRate {
        serviceId
        name
        defaultRate
      }
      createdAt
      updatedAt
      dialCode
    }
  }`
  )
  const [validationErrors, setValidationErrors] = useState({})
  const submit = useCallback((obj) => {
    const errors = validate(obj)
    if (errors && Object.keys(errors).length) {
      setValidationErrors(errors)
      onError('validation Error')
      return
    }
    mutation({ variables: obj }).then((result) => {
      onSuccess(result)
    }).catch((e) => {
      setValidationErrors({ general: 'misc.apiError' })
      onError(e)
    })
  }, [mutation, onSuccess, onError])
  return { loading, data: data ? data.updateCountry : null, error, validationErrors, submit }
}
